import { useContext } from 'react'
import SaleTypesDataContext from './SaleTypesDataContext'
import { SaleTypesContextType } from './useSaleTypes'


export const useSaleTypesData = (): SaleTypesContextType => useContext(SaleTypesDataContext)
